/* eslint-disable react/no-unescaped-entities */
import { Button, Checkbox, Dialog, DialogContent, FormControlLabel, Grid, IconButton, Slider, TextField } from '@material-ui/core';
import { gameBookTemplateActions } from '@orientaction/api-actions';
import html2canvas from 'html2canvas';
import { FC, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as Close } from '../../../../Asset/svg/close.svg';
import { ReactComponent as ZoomIn } from '../../../../Asset/svg/zoom_in.svg';
import { ReactComponent as ZoomOut } from '../../../../Asset/svg/zoom_out.svg';
import { ReactComponent as R1 } from '../../../../Asset/svg/R1.svg';
import { ReactComponent as R2 } from '../../../../Asset/svg/R2.svg';
import { ReactComponent as R3 } from '../../../../Asset/svg/R3.svg';
import { ReactComponent as R4 } from '../../../../Asset/svg/R4.svg';
import { ReactComponent as R5 } from '../../../../Asset/svg/R5.svg';
import { apiServiceNative } from '../../../../utils/fetchNative';
import styles from './style';
import Loader from '../../../../pages/AdminGame/EditPage/loader-edit';
import OaLabel from '@orientaction/commons/OaLabel';
import clsx from 'clsx';

interface IProps {
  fileUrl?: string;
  open: boolean;
  handleClose?: () => void;
  width?: any;
  height?: any;
  handlePosition?: (position: any) => void;
  handleUrl?: (url: any, id: any, iLink: string, cLink: boolean) => void;
  imgHeightB?: any;
  imgWidthB?: any;
  fileOrigin?: any;
  imgLink?: string;
  checkedLink?: boolean;
}

const ModalEditingEbook: FC<IProps> = ({
  fileUrl,
  open,
  handleClose,
  width = 508,
  height = 410,
  handlePosition,
  handleUrl,
  imgHeightB,
  imgWidthB,
  fileOrigin,
  imgLink,
  checkedLink,
}) => {
  const classes = styles();
  const LINK_IMG = 'https://storage.googleapis.com/orient-action.appspot.com/';
  const [scale, setScale] = useState<number>(1);
  const [isLong, setIsLong] = useState<any>('square');
  const [position, setPosition] = useState<any>({ x: 0, y: 0 });
  const [loading, setLoading] = useState<boolean>(false);
  const imageRef = useRef<any>(null);
  const containerRef = useRef<any>(null);
  const [widthInit, setWidthInit] = useState<any>(width);
  const [heightInit, setHeightInit] = useState<any>(height);
  const [linkImage, setLinkImage] = useState<string>(imgLink || '');
  const [checkedL, setCheckedL] = useState<boolean>(checkedLink || false);
  const typeShow = [
    {
      type: 1,
      text: '4:3',
      height: 410,
      icon: <R1 />,
    },
    {
      type: 2,
      text: '3:2',
      height: 380,
      icon: <R2 />,
    },
    {
      type: 3,
      text: '1:1',
      height: 508,
      icon: <R3 />,
    },
    {
      type: 4,
      text: '1:2',
      height: 622,
      icon: <R4 />,
    },
    {
      type: 5,
      text: '3:2',
      height: 642,
      icon: <R5 />,
    },
  ];

  useEffect(() => {
    setLinkImage(imgLink || '');
    setCheckedL(checkedLink || false);
  }, [imgLink, checkedLink]);

  const dispatch = useDispatch();
  const handleChange = (event: any, newValue: number | number[]) => {
    setScale(newValue as number);
  };
  const handleZoomIn = () => {
    const scaleIn = scale + 0.1;
    if (scaleIn > 2) {
      setScale(2);
    } else {
      setScale(scaleIn);
    }
  };
  const handleZoomOut = () => {
    const scaleOut = scale - 0.1;
    if (scaleOut < 1) {
      setScale(1);
    } else {
      setScale(scaleOut);
    }
  };
  useEffect(() => {
    const image = imageRef?.current;
    const container = containerRef?.current;
    const containerBounds = containerRef?.current?.getBoundingClientRect();
    const imageBounds = imageRef?.current?.getBoundingClientRect();
    let isDragging = false;
    let prevPosition = { x: 0, y: 0 };

    const handleMouseDown = (e: any) => {
      isDragging = scale > 1;

      prevPosition = { x: e.clientX, y: e.clientY };
    };

    const handleMouseMove = (e: any) => {
      if (!isDragging) {
        return;
      }
      if (imageBounds.width > containerBounds.width) {
        setPosition((prevPos: any) => {
          const newX = prevPos.x + e.movementX;
          const maxTranslateX = (imageBounds?.width - containerBounds?.width) / 2;
          return {
            x: Math.max(Math.min(newX, maxTranslateX), -maxTranslateX),
            y: prevPos.y,
          };
        });
      }
      if (imageBounds.height > containerBounds.height) {
        setPosition((prevPos: any) => {
          const newY = prevPos.y + e.movementY;
          const maxTranslateY = (imageBounds?.height - containerBounds?.height) / 2;
          return {
            x: prevPos.x,
            y: Math.max(Math.min(newY, maxTranslateY), -maxTranslateY),
          };
        });
      }
      // const deltaX = e.clientX - prevPosition.x;
      // const deltaY = e.clientY - prevPosition.y;
      // if (image.clientHeight > container.clientHeight) {
      //   const imgHeight = imageRef?.current?.clientHeight;
      //   const containHeight = containerRef.current?.clientHeight;
      //   const percentDiff = (imgHeight * 100) / containHeight;
      //   const minPosition = 100 - percentDiff;
      //   const containerHeight = container.clientHeight;
      //   const deltaPercentage = (deltaY / containerHeight) * 100;

      //   prevPosition = { x: e.clientX, y: e.clientY };
      //   setPosition((pos: any) => {
      //     let newPosition = pos.y + deltaPercentage;
      //     console.log({ newPosition, deltaPercentage, pos });
      //     if (newPosition < minPosition) newPosition = minPosition;
      //     if (newPosition > 0) newPosition = 0;
      //     return {
      //       y: newPosition,
      //       x: pos.x,
      //     };
      //   });
      // }

      // if (image.clientWidth > container.clientWidth) {
      //   const imgWidth = imageRef?.current?.clientWidth;
      //   const containWidth = containerRef.current?.clientWidth;
      //   const percentDiffWidth = (imgWidth * 100) / containWidth;
      //   const minPositionWidth = 100 - percentDiffWidth;
      //   const containerWidth = container.clientWidth;
      //   const deltaPercentageWidth = (deltaX / containerWidth) * 100;
      //   prevPosition = { x: e.clientX, y: e.clientY };
      //   setPosition((pos: any) => {
      //     let newPositionX = pos.x + deltaPercentageWidth;

      //     if (newPositionX < minPositionWidth) newPositionX = minPositionWidth;
      //     if (newPositionX > 0) newPositionX = 0;

      //     return {
      //       y: pos.y,
      //       x: newPositionX,
      //     };
      //   });
      // }
    };

    const handleMouseUp = () => {
      isDragging = false;
    };

    image?.addEventListener('mousedown', handleMouseDown);
    image?.addEventListener('mousemove', handleMouseMove);
    image?.addEventListener('mouseup', handleMouseUp);

    return () => {
      image?.removeEventListener('mousedown', handleMouseDown);
      image?.removeEventListener('mousemove', handleMouseMove);
      image?.removeEventListener('mouseup', handleMouseUp);
    };
  }, [imageRef, scale, fileUrl, widthInit, heightInit]);

  useEffect(() => {
    if (containerRef?.current && imageRef?.current) {
      const containerBounds = containerRef?.current?.getBoundingClientRect();
      const imageBounds = imageRef?.current?.getBoundingClientRect();
      if (imageBounds.width > containerBounds.width) {
        setPosition((prevPos: any) => {
          const newX = prevPos.x;
          const maxTranslateX = (imageBounds?.width - containerBounds?.width) / 2;
          return {
            x: Math.max(Math.min(newX, maxTranslateX), -maxTranslateX),
            y: prevPos.y,
          };
        });
      }
      if (imageBounds.height > containerBounds.height) {
        setPosition((prevPos: any) => {
          const newY = prevPos.y;
          const maxTranslateY = (imageBounds?.height - containerBounds?.height) / 2;
          return {
            x: prevPos.x,
            y: Math.max(Math.min(newY, maxTranslateY), -maxTranslateY),
          };
        });
      }
    }
  }, [scale, widthInit, heightInit]);

  const savePosition = () => {
    if (handlePosition) {
      handlePosition({
        scale,
        position: position.y,
      });
      if (handleClose) handleClose();
    }
  };

  const handleFieldChange = (field: string, value: any) => {
    dispatch(gameBookTemplateActions.updateField(field, value));
  };

  function base64ToBlob(base64: string): Blob {
    const mime = 'image/png';
    const sliceSize = 1024;

    const base64Data = base64.split(',')[1] || base64;

    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array<Uint8Array>(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array<number>(end - begin);
      for (let offset = begin, i = 0; offset < end; ++offset, ++i) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }

    return new Blob(byteArrays, { type: mime });
  }

  const uploadToServer = async (file: any) => {
    const formData = new FormData();
    formData.append('files', file);
    const response = await apiServiceNative.post(`/api/upload`, formData, true);

    dispatch(
      gameBookTemplateActions.updateField('illustration', {
        id: response[0]?.id,
        url: response[0]?.url,
      })
    );

    let idFILESTemps = localStorage.getItem('idFILESTemps') as any;
    if (!idFILESTemps) {
      idFILESTemps = [];
    } else {
      idFILESTemps = JSON.parse(idFILESTemps);
    }
    idFILESTemps.push(response[0]?.id);
    localStorage.setItem('idFILESTemps', JSON.stringify(idFILESTemps));
    return response;
  };

  const captureDivToImage = () => {
    if (containerRef.current) {
      if (fileUrl?.includes(LINK_IMG) && scale <= 1) {
        if (handleClose) {
          if (handleUrl) {
            handleUrl(fileUrl, 0, linkImage, checkedL);
          }
          handleClose();
        }
        return;
      }
      setLoading(true);
      containerRef.current.style.backgroundColor = 'transparent';
      imageRef.current.style.objectFit = 'initial';
      html2canvas(containerRef.current, { useCORS: true }).then(async canvas => {
        const imgData = canvas.toDataURL('image/png');
        containerRef.current.style.backgroundColor = '#FAFAFA';
        // dispatch(gameBookTemplateActions.updateField('tempImage', imgData));
        if (handleUrl) {
          const dataImg = await uploadToServer(base64ToBlob(imgData));
          handleUrl(dataImg[0]?.url, dataImg[0]?.id, linkImage, checkedL);
          if (handleClose) {
            setScale(1);
            setPosition({ x: 0, y: 0 });
            setLinkImage('');
            setCheckedL(false);
            handleClose();
            setLoading(false);
          }
        }
      });
    }
  };
  const closeModal = async () => {
    if (handleClose) {
      handleClose();
      setScale(1);
      setPosition({ x: 0, y: 0 });
      setHeightInit(410);
    }
  };

  useEffect(() => {
    if (imgHeightB && imgWidthB) {
      if (imgHeightB > imgWidthB) {
        setIsLong('longV');
      }
      if (imgHeightB < imgWidthB) {
        setIsLong('longH');
      }
      if (imgHeightB === imgWidthB) {
        setIsLong('square');
      }
    }
  }, [imgHeightB, imgWidthB, height, width, widthInit, heightInit]);

  const handleChangeCheckBox = (event: any) => {
    setCheckedL(event.target.checked);
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleClose?.();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.containerPaper}>
      <DialogContent className={classes.flexContent}>
        <IconButton
          style={{ background: '#E63C3C' }}
          className={classes.btnClose}
          onClick={closeModal}>
          <Close className={classes.icon} />
        </IconButton>
        <div style={{ position: 'relative' }}>
          <Grid container={true} spacing={2} justifyContent="center" style={{ marginBottom: 10 }}>
            <Grid item={true}>
              <IconButton
                color="secondary"
                style={{ background: '#000A8C' }}
                onClick={handleZoomOut}>
                <ZoomOut className={classes.icon} />
              </IconButton>
            </Grid>
            <Grid item={true} xs={4} style={{ display: 'flex', alignItems: 'center' }}>
              <Slider
                value={scale}
                min={1}
                step={0.0001}
                max={2}
                onChange={handleChange}
                aria-labelledby="non-linear-slider"
              />
            </Grid>
            <Grid item={true}>
              <IconButton
                color="secondary"
                aria-label="delete"
                style={{ background: '#000A8C' }}
                onClick={handleZoomIn}>
                <ZoomIn className={classes.icon} />
              </IconButton>
            </Grid>
          </Grid>
          <div
            ref={containerRef}
            style={{
              width: widthInit,
              height: heightInit,
              borderRadius: 5,
              background: '#F1F1F1',
              overflow: 'hidden',
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <img
              ref={imageRef}
              style={{
                width: `${
                  isLong === 'longV'
                    ? 'auto'
                    : isLong === 'square' && widthInit > heightInit
                    ? 'auto'
                    : `100%`
                }`,
                height: `${
                  isLong === 'longH'
                    ? 'auto'
                    : isLong === 'square' && widthInit < heightInit
                    ? 'auto'
                    : `100%`
                }`,
                // top: position.y === null ? '' : `${position.y}%`,
                // left: position.x === null ? '' : `${position.x}%`,
                scale: `${scale}`,
                translate: `${position.x}px ${position.y}px`,
                position: 'absolute',
              }}
              src={fileUrl}
              alt=""
              draggable={false}
            />
          </div>
          <div style={{ width: '100%', marginTop: 15 }}>
            <Grid container={true} alignItems="flex-end" justifyContent="center" spacing={4}>
              {typeShow.map((type, index) => (
                <Grid
                  key={type.text ?? index}
                  item={true}
                  style={{ display: 'flex', flexDirection: 'column' }}
                  onClick={() => {
                    setHeightInit(type.height);
                    setScale(1);
                    setPosition({ x: 0, y: 0 });
                  }}>
                  {type.icon}
                  <span style={{ textAlign: 'center', marginTop: 10 }}>{type.text}</span>
                </Grid>
              ))}
            </Grid>
            <TextField
              id="test-variable-name"
              variant="outlined"
              className={classes.formInput}
              name="link"
              value={linkImage}
              onChange={(e) => setLinkImage(e.target.value)}
              placeholder="Url pour le lien sur l'image"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedL}
                  color="primary"
                  style={{ padding: 6 }}
                  onChange={handleChangeCheckBox}
                  checkedIcon={<span className={clsx(classes.iconC, classes.checkedIcon)} />}
                  icon={<span className={classes.iconC} />}
                />
              }
              label={
                <div style={{ fontSize: 14, color: '#151528', textWrap: 'nowrap' }}>
                  Activer le lien sur l'image
                </div>
              }
            />
          </div>
          <Button
            variant="contained"
            color="primary"
            className={classes.btn}
            style={{ textTransform: 'none' }}
            onClick={captureDivToImage}>
            Valider les changements
          </Button>
        </div>
      </DialogContent>
      <Loader open={loading} text="Upload en cours..." />
    </Dialog>
  );
};
export default ModalEditingEbook;
